import PropTypes from 'prop-types';
import React from 'react';
import StepIndicator from 'components/v2/step-indicator';
import I18n from 'i18n-js';
import styles from './step-page.less';

const StepPage = ({
  goToStep,
  stepBackFunc,
  stepBackTitle,
  currentStep,
  stepName,
  totalSteps,
  children,
}) => (
  <div className={styles.stepPage}>
    <a onClick={stepBackFunc} className={styles.stepBackButton}>
      {stepBackTitle}
    </a>
    <div className={styles.pageHead}>
      <h1 className={styles.stepTitle}>
        <span className={styles.stepIndex}>
          {I18n.t(
            'phrase.geWebBulkUpload.express_web_bulk_upload_heading_step_happypath',
            { step: currentStep },
          )}:{' '}
        </span>{' '}
        {stepName}
      </h1>
      <StepIndicator
        className={styles.stepIndicator}
        goToStep={goToStep}
        currentStep={currentStep}
        totalSteps={totalSteps}
      />
    </div>
    <div className={styles.pageBody}>{children}</div>
  </div>
);

StepPage.propTypes = {
  children: PropTypes.node.isRequired,
  goToStep: PropTypes.func.isRequired,
  stepBackFunc: PropTypes.func.isRequired,
  stepBackTitle: PropTypes.string.isRequired,
  stepName: PropTypes.string.isRequired,
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
};

export default StepPage;
